import {
  styled,
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
  Typography,
  Box,
  Button,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import React from 'react'
import Link from 'next/link'
import { FlexCol } from '@/components/common/Columns'

const Accordion = styled(MuiAccordion)`
  max-width: 376px;
  border: 1px solid #bfff0b;
  background: #111303;
  margin-top: 32px;
`

const AccordionSummary = styled(MuiAccordionSummary)`
  padding: 0 20px;

  .MuiAccordionSummary-content {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`

const AccordionDetails = styled(MuiAccordionDetails)`
  padding: 0 20px 20px;
`

const TextAccordionSummary = styled(Typography)`
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  font-feature-settings: 'ss01' on, 'case' on, 'calt' off;
  color: rgba(255, 255, 255, 0.9);
`

const TextTitle = styled(Box)`
  color: #000;
  font-family: Space Grotesk;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: #bfff0b;
  padding-left: 4px;
  padding-right: 4px;
  width: fit-content;
`

const TextDesc = styled(Typography)`
  color: rgba(255, 255, 255, 0.9);
  font-feature-settings: 'case' on, 'ss01' on, 'calt' off;
  font-family: Space Grotesk;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

const CrossChainSteps = () => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <TextAccordionSummary>Cross chain steps</TextAccordionSummary>
      </AccordionSummary>

      <AccordionDetails>
        <FlexCol sx={{ gap: 20 }}>
          <FlexCol sx={{ gap: 12 }}>
            <TextTitle>Cross-chain from Bitcoin to EVM</TextTitle>
            <TextDesc>
              Connect Bitcoin wallet.Select the ETH or BNB chain, enter the receiving address on the EVM chain,wait for
              3-4 blocks, and after minting is successful, tokens are successfully bridged over to the EVM network.
            </TextDesc>
          </FlexCol>

          <FlexCol sx={{ gap: 12 }}>
            <TextTitle>Cross-chain from EVM to Bitcoin</TextTitle>
            <TextDesc>
              Connect EVM wallet.Enter the amount of tokens you want to transfer and enter the receiving address of BRC
              20.your transaction is estimated to be confirmed within 8 hours.
            </TextDesc>
          </FlexCol>

          <Link href="https://docs.multibit.exchange/multibit/tutorial/multibit-tutorial" target="_blank">
            <Button variant="text" sx={{ width: 'fit-content', height: 'fit-content', fontSize: '14px', p: 0 }}>
              View all
            </Button>
          </Link>
        </FlexCol>
      </AccordionDetails>
    </Accordion>
  )
}

export default CrossChainSteps
